export const versionCheckerMixin = {
  data() {
    return {
      currentVersion: import.meta.env.VITE_VERSION,
      newVersionAvailable: false,
    };
  },
  methods: {
    initVersionCheck() {
      // check every 5 minutes
      const frequency = 1000 * 60 * 5;

      setInterval(() => {
        this.checkVersion();
      }, frequency);
    },
    async checkVersion() {
      const url = `/version.json?t=${Date.now()}`;

      try {
        const response = await fetch(url, {
          headers: { "Content-Type": "application/json" },
        });
        if (!response.ok) return;

        const data = await response.json();
        this.newVersionAvailable = this.currentVersion !== data.version;
      } catch {
        return;
      }
    },
  },
};
